import { render, staticRenderFns } from "./IndicatorsComponent.vue?vue&type=template&id=6be9cbc7"
import script from "./IndicatorsComponent.vue?vue&type=script&lang=js"
export * from "./IndicatorsComponent.vue?vue&type=script&lang=js"
import style0 from "./IndicatorsComponent.vue?vue&type=style&index=0&id=6be9cbc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports